import { connect, MapStateToProps } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getPostsDeviationsStreamId } from '../../../../../streams/posts';
import { PostsType } from '../../../../../../types/posts';
import { AppState } from '../../../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getProfileOwnerUser } from '../../../../../selectors/users';
import { Props } from './StatusSlider';

type StateProps = Pick<
  Props,
  'streamId' | 'ownerUsername' | 'statuses' | 'total'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const streamId = getPostsDeviationsStreamId({ type: PostsType.STATUSES });
  const statuses = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, streamId)
  );
  return {
    streamId,
    ownerUsername: getProfileOwnerUser(state).username,
    statuses,
    total: streamSelectors.getTotal(state, streamId),
  };
};

export default connect(mapStateToProps);
